
import { IHocKyDangKyActionTypes } from "../../action-types/lop-tin-chi/IHocKyDangKyActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHocKyDangKyReducer } from "../../reducer-model/lop-tin-chi/IKyDangKyReducer";
const iniState: IHocKyDangKyReducer = {
  status: eReducerStatusBase.is_not_initialization,
  kyDangKys: []
};
export const hocKyDangKyReducer = (
  state: IHocKyDangKyReducer = iniState,
  action: IHocKyDangKyActionTypes
): IHocKyDangKyReducer => {
  switch (action.type) {
    case "HOC_KY_DANG_KY_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HOC_KY_DANG_KY_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        kyDangKys: action.payload,
      };
    case "HOC_KY_DANG_KY_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HOC_KY_DANG_KY_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        kyDangKyEditing: action.payload
      };
    case "HOC_KY_DANG_KY_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "HOC_KY_DANG_KY_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HOC_KY_DANG_KY_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "HOC_KY_DANG_KY_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HOC_KY_DANG_KY_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "HOC_KY_DANG_KY_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HOC_KY_DANG_KY_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
   
    default:
      return state;
  }
};
